"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/utils/encryptUtils.tsx
var encryptUtils_exports = {};
__export(encryptUtils_exports, {
  decryptData: () => decryptData,
  encryptData: () => encryptData
});
module.exports = __toCommonJS(encryptUtils_exports);
var import_crypto = __toESM(require("crypto"));

// src/sdk/error.ts
var AutumnError = class extends Error {
  message;
  code;
  constructor(response) {
    super(response.message);
    this.message = response.message;
    this.code = response.code;
  }
  toString() {
    return `${this.message} (code: ${this.code})`;
  }
  toJSON() {
    return {
      message: this.message,
      code: this.code
    };
  }
};

// src/sdk/customers/cusUtils.ts
var validateCreateCustomer = (params) => {
  if (!params.email && !params.id) {
    throw new AutumnError({
      message: "Email or id is required",
      code: "invalid_params"
    });
  }
};

// src/sdk/utils.ts
var staticWrapper = (callback, instance, args) => {
  if (!instance) {
    instance = new Autumn();
  }
  return callback({ instance, ...args });
};

// src/sdk/customers/cusMethods.ts
var customerMethods = (instance) => {
  return {
    get: (id) => staticWrapper(getCustomer, instance, { id }),
    create: (params) => staticWrapper(createCustomer, instance, { params }),
    update: (id, params) => staticWrapper(updateCustomer, instance, { id, params }),
    delete: (id) => staticWrapper(deleteCustomer, instance, { id }),
    billingPortal: (id, params) => staticWrapper(billingPortal, instance, { id, params })
  };
};
var getCustomer = async ({
  instance,
  id
}) => {
  if (!id) {
    return {
      data: null,
      error: new AutumnError({
        message: "Customer ID is required",
        code: "CUSTOMER_ID_REQUIRED"
      })
    };
  }
  return instance.get(`/customers/${id}`);
};
var createCustomer = async ({
  instance,
  params
}) => {
  validateCreateCustomer(params || {});
  return instance.post("/customers", params);
};
var updateCustomer = async ({
  instance,
  id,
  params
}) => {
  return instance.post(`/customers/${id}`, params);
};
var deleteCustomer = async ({
  instance,
  id
}) => {
  return instance.delete(`/customers/${id}`);
};
var billingPortal = async ({
  instance,
  id,
  params
}) => {
  return instance.post(`/customers/${id}/billing_portal`, params);
};

// src/sdk/general/genMethods.ts
var handleAttach = async ({
  instance,
  params
}) => {
  return instance.post("/attach", params);
};
var handleEntitled = async ({
  instance,
  params
}) => {
  return instance.post("/entitled", params);
};
var handleEvent = async ({
  instance,
  params
}) => {
  return instance.post("/events", params);
};
var handleTrack = async ({
  instance,
  params
}) => {
  return instance.post("/track", params);
};
var handleUsage = async ({
  instance,
  params
}) => {
  return instance.post("/usage", params);
};
var handleCheck = async ({
  instance,
  params
}) => {
  return instance.post("/check", params);
};

// src/sdk/products/prodMethods.ts
var productMethods = (instance) => {
  return {
    get: (id) => staticWrapper(getProduct, instance, { id }),
    create: (params) => staticWrapper(createProduct, instance, { params }),
    list: (params) => staticWrapper(listProducts, instance, { params })
  };
};
var listProducts = async ({
  instance,
  params
}) => {
  let path = "/products";
  if (params) {
    const queryParams = new URLSearchParams();
    for (const [key, value] of Object.entries(params)) {
      if (value !== void 0) {
        queryParams.append(key, String(value));
      }
    }
    const queryString = queryParams.toString();
    if (queryString) {
      path += `?${queryString}`;
    }
  }
  return instance.get(path);
};
var getProduct = async ({
  instance,
  id
}) => {
  return instance.get(`/products/${id}`);
};
var createProduct = async ({
  instance,
  params
}) => {
  return instance.post("/products", params);
};

// src/sdk/client.ts
var Autumn = class {
  secretKey;
  publishableKey;
  level;
  headers;
  url;
  constructor(options = {}) {
    try {
      this.secretKey = options.secretKey || process.env.AUTUMN_SECRET_KEY;
      this.publishableKey = options.publishableKey || process.env.AUTUMN_PUBLISHABLE_KEY;
    } catch (error) {
    }
    if (!this.secretKey && !this.publishableKey) {
      throw new Error("Autumn secret key or publishable key is required");
    }
    this.headers = {
      Authorization: `Bearer ${this.secretKey || this.publishableKey}`,
      "Content-Type": "application/json"
    };
    this.url = options.url || "https://api.useautumn.com/v1";
    this.level = this.secretKey ? "secret" : "publishable";
  }
  getLevel() {
    return this.level;
  }
  async handleResponse(response) {
    if (response.status < 200 || response.status >= 300) {
      let error;
      try {
        error = await response.json();
      } catch (error2) {
        return {
          data: null,
          error: new AutumnError({
            message: "Something went wrong",
            code: "internal_error"
          })
        };
      }
      return {
        data: null,
        error: new AutumnError({
          message: error.message,
          code: error.code
        })
      };
    }
    try {
      return {
        data: await response.json(),
        error: null
      };
    } catch (error) {
      return {
        data: null,
        error: new AutumnError({
          message: "Failed to parse Autumn API response",
          code: "internal_error"
        })
      };
    }
  }
  async get(path) {
    const response = await fetch(`${this.url}${path}`, {
      headers: this.headers
    });
    return this.handleResponse(response);
  }
  async post(path, body) {
    const response = await fetch(`${this.url}${path}`, {
      method: "POST",
      headers: this.headers,
      body: JSON.stringify(body)
    });
    return this.handleResponse(response);
  }
  async delete(path) {
    const response = await fetch(`${this.url}${path}`, {
      method: "DELETE",
      headers: this.headers
    });
    return this.handleResponse(response);
  }
  static customers = customerMethods();
  static products = productMethods();
  customers = customerMethods(this);
  products = productMethods(this);
  static attach = (params) => staticWrapper(handleAttach, void 0, { params });
  static usage = (params) => staticWrapper(handleUsage, void 0, { params });
  async attach(params) {
    return handleAttach({
      instance: this,
      params
    });
  }
  /**
   * @deprecated This method is deprecated and will be removed in a future version.
   * Please use the new check() method instead.
   */
  static entitled = (params) => staticWrapper(handleEntitled, void 0, { params });
  /**
   * @deprecated This method is deprecated and will be removed in a future version.
   * Please use the new check() method instead.
   */
  async entitled(params) {
    return handleEntitled({
      instance: this,
      params
    });
  }
  static check = (params) => staticWrapper(handleCheck, void 0, { params });
  async check(params) {
    return handleCheck({
      instance: this,
      params
    });
  }
  /**
   * @deprecated This method is deprecated and will be removed in a future version.
   * Please use the new track() method instead.
   */
  static event = (params) => staticWrapper(handleEvent, void 0, { params });
  /**
   * @deprecated This method is deprecated and will be removed in a future version.
   * Please use the new track() method instead.
   */
  async event(params) {
    return handleEvent({
      instance: this,
      params
    });
  }
  static track = (params) => staticWrapper(handleTrack, void 0, { params });
  async track(params) {
    return handleTrack({
      instance: this,
      params
    });
  }
  async usage(params) {
    return handleUsage({
      instance: this,
      params
    });
  }
};

// src/utils/encryptUtils.tsx
var getKey = () => {
  if (!process.env.AUTUMN_SECRET_KEY) {
    throw new AutumnError({
      message: "Autumn secret key not found in process.env.AUTUMN_SECRET_KEY. Please set it in your .env file.",
      code: "secret_key_not_found"
    });
  }
  return import_crypto.default.createHash("sha512").update(process.env.AUTUMN_SECRET_KEY).digest("hex").substring(0, 32);
};
function encryptData(data) {
  let key;
  try {
    key = getKey();
  } catch (error) {
    throw new AutumnError({
      message: `Failed to encrypt customer ID. ${error.message}`,
      code: "encrypt_customer_id_failed"
    });
  }
  const iv = import_crypto.default.randomBytes(16);
  const cipher = import_crypto.default.createCipheriv("aes-256-cbc", key, iv);
  const encrypted = Buffer.concat([
    cipher.update(data, "utf8"),
    cipher.final()
  ]);
  const result = Buffer.concat([iv, encrypted]);
  return result.toString("base64");
}
function decryptData(encryptedData) {
  const buffer = Buffer.from(encryptedData, "base64");
  const iv = buffer.slice(0, 16);
  const encrypted = buffer.slice(16);
  const key = getKey();
  const decipher = import_crypto.default.createDecipheriv("aes-256-cbc", key, iv);
  const decrypted = Buffer.concat([
    decipher.update(encrypted),
    decipher.final()
  ]);
  return decrypted.toString("utf8");
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  decryptData,
  encryptData
});
